<script lang="ts" setup>
import { DevicePhoneMobileIcon } from "@heroicons/vue/24/outline";
import { computed, defineAsyncComponent } from "vue";
import Pill from "@/components/_elements/Pill.vue";
import { analytics } from "@/services/segment.ts";

const props = defineProps<{
    isEnabled?: boolean;
    icon?: string;
    onEnable?: () => void;
    onDisable?: () => void;
}>();

const handleButtonClick = () => {
    // Segment tracking
    analytics.track("2FA Enablement Started");

    if (props.isEnabled && props.onDisable) {
        props.onDisable();
    } else if (!props.isEnabled && props.onEnable) {
        props.onEnable();
    }
};

const IconComponent = computed(() => {
    return defineAsyncComponent(() =>
        import(`@heroicons/vue/24/outline`)
            .then((module) => {
                const iconName = props.icon;
                if (iconName && module[iconName]) {
                    return module[iconName];
                }
                return DevicePhoneMobileIcon; // fallback
            })
            .catch(() => DevicePhoneMobileIcon)
    );
});
</script>

<template>
    <div
        class="mb-4 bg-gray-50 border border-gray-300 rounded-md p-6 flex gap-2 items-center justify-between"
    >
        <div class="flex gap-2 items-center">
            <component v-if="props.icon" :is="IconComponent" class="h-8 w-8" />
            <p class="font-bold text-black"><slot>Text</slot></p>
            <Pill
                v-if="props.isEnabled"
                backgroundColor="green-100"
                textColor="green-800"
            >
                Active
            </Pill>
        </div>
        <button
            type="submit"
            @click="handleButtonClick"
            class="button small rounded-md shadow-none text-white border-0"
            :class="
                props.isEnabled
                    ? 'bg-gray-900 hover:bg-gray-800'
                    : 'bg-blue-700 hover:bg-blue-800'
            "
        >
            {{ props.isEnabled ? "Disable" : "Enable" }}
        </button>
    </div>
</template>
